import { useState, type ChangeEvent } from 'react';
import { t } from '../i18n';

/**
 * A password field with a "show" button (owner request, 2026-10-01): tapping the eye shows what
 * was typed, so a long password (FR-045: 16+ characters) can be checked before signing in.
 * The field goes back to hidden when the page is left.
 */
export function PasswordInput({
  id,
  value,
  autoComplete,
  onChange,
}: {
  id: string;
  value: string;
  autoComplete: 'current-password' | 'new-password';
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}) {
  const [shown, setShown] = useState(false);
  return (
    <div className="password-input">
      <input
        id={id}
        type={shown ? 'text' : 'password'}
        required
        autoComplete={autoComplete}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        value={value}
        onChange={onChange}
      />
      <button
        type="button"
        className="password-input__toggle"
        aria-label={t(shown ? 'signIn.hidePassword' : 'signIn.showPassword')}
        aria-pressed={shown}
        aria-controls={id}
        onClick={() => setShown((now) => !now)}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
          <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
          {shown && <path d="M4 4l16 16" stroke="currentColor" strokeWidth="2" />}
        </svg>
      </button>
    </div>
  );
}
